function Announcer(props) {
    return (
        <div className="recruit_contents">
            <div className="recruit_titleline_w">
                <h4 className="recruit_titleline_info">아나운서</h4>
                <h5 className="recruit_titleline_title">아나운서</h5>
            </div>
            <div className="recruit_subtitleline_w">
                <h6 className="recruit_titleline_info">직무소개</h6>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">직무 및 필요역량</h7>
                <p className="recruit_subinfo_text">
                    아나운서는 뉴스 앵커, 교양/예능 프로그램의 MC/출연자, 스포츠 중계 캐스터, 라디오 DJ 등 SBS 프로그램에서 다양한 역할을 하게 됩니다. 또한, 자신이 맡은 프로그램 외에도 기본적인 업무, 예를 들어 라디오 뉴스, TV 일반뉴스 및 각종 내레이션 등을 해야 합니다.<br />
                    따라서 정확한 발음, 적확한 표현, 전달력 있는 목소리가 필수적입니다. 또한, 출연자 및 제작진과의 공감과 소통 능력도 필요합니다.<br />
                    신뢰감, 친밀감 등이 중요한 요소이며 이는 회사의 브랜드 이미지와도 직결됩니다.
                </p>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">부서 소개</h7>
                <p className="recruit_subinfo_text">
                    아나운서팀은 SBS에 소속된 아나운서들로 구성되어 있고 프로그램 배정을 비롯해 아나운서의 교육, 육성 등을 주관합니다.
                </p>
                <em className="recruit_bold_text">보도</em>
                <p className="recruit_subinfo_text">
                    8뉴스를 비롯한 TV 일반뉴스, 라디오 뉴스 등 뉴스 진행을 맡습니다. 뉴스는 아나운서의 기본 업무입니다. <br />
                    정확한 발음으로 이해하기 쉽게, 전달력 있는 목소리로 뉴스를 진행합니다. 갑자기 발생하는 뉴스특보에도 순발력 있게 대처해야 합니다.
                </p>
                <em className="recruit_bold_text">교양</em>
                <p className="recruit_subinfo_text">
                    다양한 교양 프로그램에서 MC나 출연자 역할을 합니다. 편안하고 안정감 있게 프로그램을 이끌고 정확한 정보 전달을 합니다.<br />
                    내레이션도 아나운서의 역할입니다.
                </p>
                <em className="recruit_bold_text">예능</em>
                <p className="recruit_subinfo_text">
                    예능 프로그램의 진행을 맡기도 하고 출연자로서 자신의 끼와 개성을 발휘하기도 합니다.
                </p>
                <em className="recruit_bold_text">스포츠</em>
                <p className="recruit_subinfo_text">
                    스포츠 경기의 중계 캐스터역할을 합니다. 올림픽, 아시안게임, 월드컵 등 스포츠 빅이벤트 뿐만 아니라 수시로 열리는 스포츠 경기의 중계방송을
                    진행합니다. 스포츠 뉴스나 스포츠 투나잇 등 스포츠 프로그램도 스포츠 방송의 영역입니다.
                </p>
                <em className="recruit_bold_text">라디오</em>
                <p className="recruit_subinfo_text">
                    라디오 프로그램의 DJ, 출연자가 될 수 있으며 음악, 책, 영화 등 자신의 전문성을 가지고 청취자들과 소통, 공감할 줄 알아야 합니다. <br />
                    또한, 시사 프로그램도 진행할 수 있으며, 그를 위해선 날카로운 분석력과 비판 능력을 갖춰야 합니다.
                </p>
                <em className="recruit_bold_text">그 외</em>
                <p className="recruit_subinfo_text">
                    표준어와 바른 우리말 사용에 앞장섭니다. 사내 교육 주관, 국립국어원과 협업 등을 통해 올바른 우리말 문화 정착을 위해 노력합니다. <br />
                    또 사내에서 열리는 드라마 제작발표회를 비롯해 방송대상이나 각종 영화제 등 다양한 행사 진행을 맡습니다. 유튜브, 팟캐스트 등의 뉴미디어 영역도 확장되고 있습니다.
                </p>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">커리어패스 및 비전</h7>
                <p className="recruit_subinfo_text">
                    SBS는 시대의 변화에 발맞추기 위하여 다양한 프로그램을 제작하고 있고, SBS 아나운서 역시 본연의 직무에 충실하면서도 새로운 형식의<br />
                    프로그램을 진행할 수 있는 많은 기회를 가질 수 있습니다. 또한, 팀 차원에서 아나운서들의 관심사를 파악하여 전문가 초빙 교육을 하는 등<br />
                    전문성을 개발할 기회를 적극적으로 부여하고 있습니다. 전문성을 갖춘 실력 있는 아나운서가 되기를 원하시는 많은 분들의 도전을<br />기다립니다.
                </p>
            </div>
            <div className="recruit_subtitleline_w">
                <h6 className="recruit_titleline_info">선배인터뷰</h6>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">본인 소개</h7>
                <p className="recruit_subinfo_text">
                    안녕하세요! SBS 아나운서 김선재입니다.
                </p>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">아나운서가 된 계기는?</h7>
                <p className="recruit_subinfo_text">
                    개인적으로는 재미있으면서 적성에도 맞고 의미까지 있는 일이라 생각해서 아나운서를 선택했어요.<br />
                    사실 어떤 일이든 직업이 되면 처음에 있던 재미도 사라지기 마련인데요, 제가 지금까지도 이 일을 즐겁게 하고 있는 것을 보면,<br />
                    또 일하면서 보람을 느끼는 순간들이 계속 찾아오는 것을 보면 정말 좋은 선택을 했다는 생각이 듭니다. <br />
                    앞으로도 오래오래 이 일을 하고 싶어요.
                </p>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">본인의 일에서 보람을 느낄 때는?</h7>
                <p className="recruit_subinfo_text">
                    선거나 올림픽 등 국가적, 세계적으로 중요한 일이 있을 때 최일선에서 그 분위기를 동료들과 함께 느끼고 그 소식을 적절하게 전달했을 때,<br />
                    그리고 그로 인해 세상이 조금 더 나은 방향으로 바뀔 때 큰 보람을 느낍니다. 그리고 이렇게 굵직한 이벤트가 아니더라도 하루하루 시청자,<br />
                    청취자들을 만나면서 나의 말로 인해 누군가 위안을 받고 누군가가 하루를 즐겁게 보낼 때, 보람을 느낍니다.
                </p>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">입사지원자에게 해주고 싶은 말</h7>
                <p className="recruit_subinfo_text">
                    우선 얼른 동료로 뵙고 싶고요!<br />
                    저는 아나운서의 가장 큰 무기가 &#39;호기심&#39;이라고 생각합니다. 호기심의 다른 표현은 &#39;관심&#39;일 수도 있을 텐데요, 내 주변에 대한 관심,<br />
                    다른 이들에 대한 관심, 더 나아가서 사회와 세상에 대한 관심이 있어야, 그러니까 궁금한 것이 있어야 질문도 생기고 대화도 할 수 있다고<br />생각합니다.
                    결국, 아나운서는 나의 언어로 누군가에게 질문을 던지고 대화하는 것이니까요! 그리고 미디어 시장이 빠르게 변화하는 만큼<br />저희 아나운서들도 유튜브 등
                    새로운 일들도 많이 하고 있으니까요. 많이 지원해주시면 좋겠습니다!
                </p>
            </div>
        </div>
    );
}

export default Announcer;

